import styled from 'styled-components';

import { colors, fontSizes, letterSpacing, spacing } from 'ui/theme';
import { useAnimatedPositionTransition } from 'utils/hooks/useAnimatedPositionTransition';

const Wrapper = styled.li`
  margin: ${spacing.double} 0;
  display: grid;
  grid-gap: ${spacing.half};
  grid-template-columns: 1fr min-content 1fr;
  align-items: center;
`;

const Border = styled.div`
  display: block;
  height: ${spacing.single};
  background-color: ${colors.grey15};
`;

const Text = styled.div`
  font-size: ${fontSizes.s11};
  letter-spacing: ${letterSpacing.pos200};
  color: ${colors.textSecondary};
  text-transform: uppercase;
  white-space: nowrap;
`;

export const InactiveChannelDivider = () => (
  <Wrapper data-test="inactive-divider" ref={useAnimatedPositionTransition()}>
    <Border />
    <Text>Inactive Channels</Text>
    <Border />
  </Wrapper>
);
